import { faCircleMinus, faUser } from '@fortawesome/pro-solid-svg-icons'
import useAppView from 'Core/Hooks/useAppView'
import useMultiSlice from 'Core/Hooks/useMultiSlice'
import { createRsrcKey } from 'features/resources'
import { getHTMLDataTestID } from 'infra/utils'
import { Button, Label, SelectDateTime, SelectDropDown } from 'procyon-ui'
import React, { useRef, useState } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { EntityPicker, FullScreenContentModal } from 'V2Components'

const Filters = ({ filters, onFilterChange, onApplyClick, rsrc, userName }) => {
  const { appView } = useAppView()
  const { slices } = useMultiSlice(['userList'])

  const [selectedEntities, setSelectedEntities] = useState(filters.selectedUsers || [])
  const [showSelectUsers, setShowSelectUsers] = useState(false)
  const _prevUsers = useRef([])

  const handleUserRemove = (key) => {
    const nextSelected = selectedEntities.filter((e) => createRsrcKey(e) !== key)
    setSelectedEntities(nextSelected)
    onFilterChange({ selectedUsers: nextSelected })
  }

  return (
    <div>
      <div className='border border-[#D8DDE4] px-4 py-3 rounded-md flex justify-between items-center'>
        <div className='flex items-center gap-4'>
          From
          <SelectDateTime
            data-testid={getHTMLDataTestID('activity-log', 'input', 'start-date-time')}
            value={filters.startDateTime.toDate()}
            onChange={(v) => onFilterChange({ startDateTime: v })}
            maxDate={moment()}
          />
          To
          <SelectDateTime
            data-testid={getHTMLDataTestID('activity-log', 'input', 'end-date-time')}
            value={filters.endDateTime.toDate()}
            onChange={(v) => onFilterChange({ endDateTime: v })}
            maxDate={moment()}
          />
          {!rsrc && (
            <>
              <SelectDropDown
                data-testid={getHTMLDataTestID('activity-log', 'input', 'resource-kind', 'dropdown')}
                sx={{ width: '150px' }}
                menuItems={[
                  { label: 'All Resources', value: 'all' },
                  { label: 'Applications', value: 'Application' },
                  { label: 'AppRoles', value: 'AppRole' },
                  { label: 'Servers', value: 'Server' }
                ]}
                onChange={(e) => onFilterChange({ resourceKindFilter: e.target.value })}
                value={filters.resourceKindFilter}
              />

              <SelectDropDown
                data-testid={getHTMLDataTestID('activity-log', 'input', 'all-logs', 'dropdown')}
                //@ts-ignore
                id='all-logs-dropdown'
                multiple
                sx={{ width: '200px' }}
                menuItems={[
                  { label: 'Audit Logs', value: 'audit-log' },
                  { label: 'Event Logs', value: 'event-log' },
                  { label: 'Proxy Audit Logs', value: 'proxy-audit-log' },
                  { label: 'Proxy Event Logs', value: 'proxy-event-log' }
                ]}
                onChange={(e) => onFilterChange({ queryIndexes: e.target.value })}
                //@ts-ignore
                value={filters.queryIndexes}
              />
            </>
          )}

          {appView === 'admin' && !userName && (
            <Button
              data-testid={getHTMLDataTestID('activity-log', 'button', 'select-users')}
              onClick={() => {
                _prevUsers.current = selectedEntities
                setShowSelectUsers(true)
              }}
              size='md'
              variant='grayBlue'
              icon={faUser}
            >
              Select Users
            </Button>
          )}

          <Button
            data-testid={getHTMLDataTestID('activity-log', 'button', 'apply')}
            onClick={onApplyClick}
            size='md'
            variant='primary'
          >
            Apply
          </Button>
        </div>

        {showSelectUsers && (
          <FullScreenContentModal width='auto'>
            <EntityPicker
              title='Select Users for Query Filter'
              entities={slices.userList}
              selectedEntities={selectedEntities}
              setSelectedEntities={setSelectedEntities}
              onCancel={() => {
                setSelectedEntities(_prevUsers.current)
                setShowSelectUsers(false)
              }}
              onContinue={() => {
                setShowSelectUsers(false)
                onFilterChange({ selectedUsers: selectedEntities })
              }}
            />
          </FullScreenContentModal>
        )}
      </div>
      <div className='flex gap-2 mt-2'>
        {selectedEntities.map((u) => {
          return (
            <Label
              key={createRsrcKey(u)}
              data-tesetid={getHTMLDataTestID('activity-log', 'label', u.ObjectMeta.Name, 'user')}
              onClick={() => {
                handleUserRemove(createRsrcKey(u))
              }}
              variant='grayBlue'
              iconButton={faCircleMinus}
              text={u.Spec.UserName === '' ? u.Spec.FullName : u.Spec.UserName}
            />
          )
        })}
      </div>
    </div>
  )
}

export { Filters }
